// extracted by mini-css-extract-plugin
module.exports = {"form":"ui_form__1UTfs","input":"ui_input__1fAgV","cancel":"ui_cancel__1QebL"};